/** App namespace для ключей form submission memory в `localStorage`. */
export const FORM_SUBMISSION_MEMORY_NAMESPACE = "omp:form-submission-memory";

/** Глобальная версия envelope/physical layout; bump при breaking change storage-модуля. */
export const FORM_SUBMISSION_MEMORY_STORAGE_FORMAT_VERSION = 1;

/** Legacy namespaces для одноразовой очистки при bump `FORM_SUBMISSION_MEMORY_STORAGE_FORMAT_VERSION`. */
export const FORM_SUBMISSION_MEMORY_LEGACY_NAMESPACE_PREFIXES = ["filter-memory"] as const;
